import { gsap } from "gsap";

$(document).ready(function () {
  if ($(".c-people").length > 0) {
    if ($(window).width() > 1023) {
      $(document).on("click", ".c-person", function (e) {
        // on click of person, get personID
        var personID = $(this).attr("data-id");

        if ($(this).hasClass("active")) {
          //---------- Turning off current active person
          $(this).removeClass("active");
          // Empty bio div
          $(this)
            .parent(".c-people__row")
            .find(".c-person__information")
            .slideUp(500);

          setTimeout(function () {
            $(this)
              .parent(".c-people__row")
              .find(".c-person__information")
              .empty();
          }, 500);
        } else {
          //---------- update active item and show bio

          $(".c-person").removeClass("active");
          $(this).addClass("active");
          // get relevant .text from .disembodied-bio-text based on id
          var selectedBio = $(
            ".c-disembodied-bio-text .c-person__bio-text#" + personID
          ).clone();

          // Get closest .bios div
          var bioDiv = $(this)
            .parent(".c-people__row")
            .find(".c-person__information");

          // clear any existing contents
          bioDiv.slideUp(500);
          bioDiv.empty();
          // insert into person's closest .bios
          bioDiv.append(selectedBio);
          // show .bios div
          // if (bioDiv.not(":visible")) {
          bioDiv.slideDown(500);
          // }

          // Close other .bios div
          $(".c-people .c-person__information").not(bioDiv).slideUp(500);
        }
      });
    }
  }

  // Set up pulse arrows with different animation
  $(".c-person").each(function (i, el) {
    // create a timeline for this element in paused state
    var tl = gsap.timeline({ paused: true });

    // get arrow
    var pulse = $(el).find(".simple-arrow");

    // create tween of the timeline in a variable
    var t = tl
      .from($(pulse).find(".arrow-left"), { duration: 0.3, x: 110 })
      .from(
        $(pulse).find(".heartbeat-line"),
        { duration: 0.2, scale: 0, transformOrigin: "0 80%" },
        0
      );

    // store the tween timeline in the javascript DOM node
    pulse.animation = t;

    // listen for hover
    $(el).hover(
      function () {
        pulse.animation.play();
      },
      function () {
        pulse.animation.timeScale(2).reverse();
      }
    );

    $(el).click(function () {
      pulse.animation.timeScale(3).reverse();
      gsap.to($(pulse), { rotation: 90, duration: 0.1 });
      // remove rotated class from other arrows and rotate back to 0
      gsap.to($(".simple-arrow.rotated"), { rotation: 0, duration: 0.1 });
      $(".simple-arrow.rotated").removeClass("rotated");
      // Apply class to current
      $(pulse).toggleClass("rotated");
    });
  });

  // Bios filter
  if ($(".PeoplePage .ajax-filter-form").length > 0) {
    var form = $(".ajax-filter-form");
    var url = form.data("url");

    form.find("input").change(function (e) {
      e.preventDefault();

      $.ajax({
        type: "GET",
        url: url,
        data: form.serialize(),
        success: function (response) {
          $(".c-people-holder").html(response);
          var newUrl = $(".people__all").data("url");
          history.pushState(null, null, newUrl);
        },
      });
    });
  }
});
